import React from 'react';
import PropTypes from 'prop-types';

import UniLogo from '@spa/shared/svg/uni-logo';
import { Subtitle, Title, Wrapper } from './styles';
import KitchenPlaceholder from '@spa/shared/svg/kitchen-placeholder';
import LivingRoomPlaceholder from '@spa/shared/svg/living-room-placeholder';
import BathroomPlaceholder from '@spa/shared/svg/bathroom-placeholder';
import WCPlaceholder from '@spa/shared/svg/wc-placeholder';
import GeneralPlaceholder from '@spa/shared/svg/general-placeholder';
import BedroomPlaceholder from '@spa/shared/svg/bedroom-placeholder';
import LaundryPlaceholder from '@spa/shared/svg/laundry-placeholder';

export const PLACEHOLDER_TYPES = {
  KITCHEN: 'kitchen',
  BATHROOM: 'bathroom',
  LIVING_ROOM: 'living-room',
  BEDROOM: 'bedroom',
  WC: 'wc',
  LAUNDRY: 'laundry',
  GENERAL: 'general'
};

const PLACEHOLDER_SVG_MAP = {
  [PLACEHOLDER_TYPES.KITCHEN]: <KitchenPlaceholder />,
  [PLACEHOLDER_TYPES.BATHROOM]: <BathroomPlaceholder />,
  [PLACEHOLDER_TYPES.LIVING_ROOM]: <LivingRoomPlaceholder />,
  [PLACEHOLDER_TYPES.BEDROOM]: <BedroomPlaceholder />,
  [PLACEHOLDER_TYPES.WC]: <WCPlaceholder />,
  [PLACEHOLDER_TYPES.LAUNDRY]: <LaundryPlaceholder />,
  [PLACEHOLDER_TYPES.GENERAL]: <GeneralPlaceholder />
};

const Placeholder = ({ type = PLACEHOLDER_TYPES.GENERAL, title, subtitle, onClick = () => {} }) => (
  <Wrapper onClick={onClick}>
    <UniLogo className="logo" />
    {PLACEHOLDER_SVG_MAP[type] ?? PLACEHOLDER_SVG_MAP[PLACEHOLDER_TYPES.GENERAL]}
    {title && <Title>{title}</Title>}
    {subtitle && <Subtitle>{subtitle}</Subtitle>}
  </Wrapper>
);

Placeholder.propTypes = {
  type: PropTypes.oneOf(Object.values(PLACEHOLDER_TYPES)),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onClick: PropTypes.func
};

export default Placeholder;
